import { beingInstance, notBlank, parseJsonArrayAs, parseString, syncCallback } from "@de-xima/xima-common-js-lang";
import { findWidgetForElement, runRemoteCommand } from "./Util.ts";
import $ from "jquery";
import { toElements } from "@de-xima/xima-common-js-dom";
import { onToggleGroupHeader } from "../extra/FormOverview.ts";

interface IItemSearchFilter {
  empty: boolean;
  test: (itemText: string, itemTags: string[]) => boolean;
}

function createItemSearchFilter(searchText: string, searchTags: string[]): IItemSearchFilter {
  const hasSearchTextFilter = notBlank(searchText);
  const hasSearchTagsFilter = searchTags.length > 0;
  const searchTextLower = searchText.toLowerCase();
  const searchTagSet = new Set(searchTags);
  return {
    empty: !hasSearchTagsFilter && !hasSearchTextFilter,
    test: (text, tags) => {
      const textMatches = !hasSearchTextFilter || text.toLowerCase().includes(searchTextLower);
      const anyTagMatches = !hasSearchTagsFilter || tags.filter((tag) => searchTagSet.has(tag)).length > 0;
      return textMatches && anyTagMatches;
    },
  };
}

function expandPanelsWithMatchingPlugins() {
  const pluginLists = $(".plugin-store__list");
  for (const el of pluginLists) {
    const pluginList = $(el);
    if (!pluginList.hasClass("Hidden")) {
      continue;
    }
    const pluginItems = pluginList.children();
    const foundPlugins = pluginItems.hasClass("data-entry-unfiltered");
    if (foundPlugins) {
      const headerRow = pluginList.prev();
      if (headerRow.hasClass("xfc-header-row")) {
        const headerRowButton = headerRow.find(".header-row-button");
        onToggleGroupHeader(headerRowButton);
      }
    }
  }
}

export async function checkForAvailableUpdates(): Promise<void> {
  FacesHttp?.SocketApi?.onNoneConnecting(
    syncCallback(async () => {
      await runRemoteCommand(BackendCommand?.pluginUpdateInit);
    }),
  );
}

export async function checkPluginStoreAvailable(): Promise<void> {
  FacesHttp?.SocketApi?.onNoneConnecting(
    syncCallback(async () => {
      await runRemoteCommand(BackendCommand?.checkPluginStoreAvailable);
    }),
  );
}

/**
 * This function calculates if the found plugin description text is higher than 200px.
 * If it is above 200px the "Show more" button is displayed. Otherwise the button is
 * hidden and the description is expanded to the full height.
 */
export async function showPluginDescExpandButton(): Promise<void> {
  const descHeight = $(".plugin-desc__text").height();
  const pluginDescButton = $(".plugin-desc__expand-link");
  if (descHeight && descHeight > 200) {
    pluginDescButton.show();
  } else {
    pluginDescButton.hide();
    $(".plugin-desc").addClass("expanded");
  }
}

/**
 * This function adds/removes the "expanded" class to the plugin description element,
 * so that the description extension is toggled.
 */
export function expandPluginDesc(): void {
  const pluginDesc = $(".plugin-desc");
  const isExpanded = pluginDesc.hasClass("expanded");

  if (!isExpanded) {
    pluginDesc.addClass("expanded");
  } else {
    pluginDesc.removeClass("expanded");
  }
}

/**
 * Filters the list of plugins in the plugin store according to the current filter values.
 */
export function searchPluginStore(): void {
  const searchInput = document.querySelector(".plugin-store__search");
  const tagMenu = findWidgetForElement(".plugin-store__tag_filter", PrimeFaces.widget.SelectManyMenu);
  const searchText = searchInput instanceof HTMLInputElement ? searchInput.value : "";

  const searchTags = tagMenu?.checkboxes
    ?.toArray()
    .filter(beingInstance(HTMLElement))
    .filter((e) => {
      const el = $(e);
      return el.hasClass("ui-state-active");
    })
    .map((e) => {
      const el = $(e);
      const label = el.closest(".ui-selectlistbox-item").find("td label.listitem-label");
      return parseString(label.text());
    });

  const filter = createItemSearchFilter(searchText, searchTags ? searchTags : []);

  const items = document.querySelectorAll(".plugin-store__listing .ui-search-item");

  if (filter.empty) {
    for (const item of toElements(items)) {
      item.classList.remove("data-entry-filtered");
      item.classList.remove("data-entry-unfiltered");
    }
  } else {
    for (const item of toElements(items)) {
      const itemText = item.querySelector(".ui-search-data")?.textContent ?? "";
      const itemTags = parseJsonArrayAs(item.querySelector(".ui-search-tags")?.textContent, parseString);
      const matches = filter.test(itemText, itemTags);
      if (matches) {
        item.classList.remove("data-entry-filtered");
        item.classList.add("data-entry-unfiltered");
      } else {
        item.classList.add("data-entry-filtered");
        item.classList.remove("data-entry-unfiltered");
      }
    }
  }

  expandPanelsWithMatchingPlugins();
}
